import React, { useEffect, useState } from 'react';
import MovieCard from '../../component/Movies/MovieCard';
import DetailsFile from '../../component/DetailsFile';

const API_KEY = '2fa17ff7cae269858213010f9e657124';
const GENRE_ID = 18; // Drama genre ID

const fetchMovies = async () => {
  const response = await fetch(
    `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&sort_by=release_date.desc&with_genres=${GENRE_ID}`
  );
  const data = await response.json();
  return data.results;
};

const fetchMovieCredits = async (movieId) => {
  const response = await fetch(
    `https://api.themoviedb.org/3/movie/${movieId}/credits?api_key=${API_KEY}`
  );
  const data = await response.json();
  return data.cast;
};

const MovieDetail = () => {
  const [movies, setMovies] = useState([]);
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getMoviesWithActors = async () => {
      const movies = await fetchMovies();
      const moviesWithActors = await Promise.all(
        movies.map(async (movie) => {
          const cast = await fetchMovieCredits(movie.id);
          const actors = cast.map((actor) => actor.name);
          return { ...movie, actors };
        })
      );
      setMovies(moviesWithActors);
      setLoading(false);
    };

    getMoviesWithActors();
  }, []);

  const handleMovieClick = (movie) => {
    setSelectedMovie(movie);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-4">
      {selectedMovie ? (
        <DetailsFile detail={selectedMovie} />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} onClick={handleMovieClick} />
          ))}
        </div>
      )}
    </div>
  );
};

export default MovieDetail;
